<template>
  <div style="background: #fff;width: 100%;height:auto;">
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>contact us</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content">
      <div class="item" v-for="(item, index) in addresList" :key="index">
        <h2>{{ item.name }}</h2>
        <!-- <p><span>Company:</span>   {{ item.company }}</p> -->
        <p><span>Address:</span>  {{ item.address }}</p>
        <p><span>Telephone:</span>   {{ item.telephone }}</p>
        <p><span>E-mail:</span>   {{ item.email }}</p>
        <!-- <button class="btn" @click="changeMap(item.lng,item.lat)">View Map</button> -->
      </div>
    </div>
    <!-- <baidu-map class="map" :center="{'lng': `${lngCenter}`, 'lat': `${latCenter}`}" :zoom="1" >
      <bm-marker :position="{'lng': `${item.lng}`, 'lat': `${item.lat}`}" :dragging="true" animation="BMAP_ANIMATION_BOUNCE" v-for="(item, index) in addresList" :key="index">
        <bm-label content="" :labelStyle="{color: 'red', fontSize : '24px'}" :offset="{width: -35, height: 30}"/>
      </bm-marker>
    </baidu-map> -->
  </div>
</template>



<script>


    export default {
        name: 'Contact',
        data () {
            return {
              addresList: [
                { name: 'USA', company: 'Kelliop Biotech Co,.Ltd', address: '39600 Eureka Drive, Newark, CA 94560.', telephone: '+1-510-327-5712', email: 'c@kelliop.com', lng: '-121.9903363177865', lat: '37.516593087948586' },
                { name: 'Singapore', company: 'KELLIOP PTE.LTD', address: '3 Temasek Avenue #27-02 Centennial Tower,Singapore (039190)', telephone: '+65 83175765', email: 'a@kelliop.com', lng: '103.86624663022401', lat: '1.2998998767428924' },
                // { name: 'Shanghai', company: 'Day 6 Biotech Co,.Ltd', address: 'H301, No.1188 Lianhang Road, Minhang District, Shanghai（Distributor：Day6 Biotech Co. Ltd）', telephone: '', email: 'service@kelliop.com', lng: '121.530533', lat: '31.085692' },
                // { name: 'Europe', company: '', address: '', telephone: '', email: '', lng: '', lat: '' },
              ],
              lngCenter: '116.404',
              latCenter: '39.915',
            }
        },
        mounted() {
          this.backTop();
        },
        methods: {
          changeMap(lng, lat) {
            // console.log(lng, lat);
            // this.lngCenter = lng;
            // this.latCenter = lat;
            // console.log(document.documentElement.scrollHeight);
            // let scrollHeight = document.documentElement.scrollHeight
            // let scroll = scrollHeight - 1000;
            // console.log(scroll, 'scroll');
            // window.scrollTo(0, scroll);
          },
          backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
              this.timer = setInterval(() => {
                  let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                  let ispeed = Math.floor(-osTop / 5)
                  document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                  if (osTop === 0) {
                      clearInterval(this.timer)
                  }
              }, 30)
          },
        },
    }
</script>

<style scoped>
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
.content {
  margin-top:50px;
  display:flex;
  /* align-items: center; */
  padding: 0 139px;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}
.item {
  /* flex:1; */
  width:45%;
  margin-bottom:100px;
}
h2 {
  font-size:40px;
  color:#000000;
  font-weight:bold;
  margin-bottom:34px;
}
.item p {
  font-size:24px;
  color:#022032;
  line-height:35px;
}
.item p span {
  font-weight:bold;
}
.btn {
  background-color:#00718c;
  border-radius:20px;
  width:138px;
  height:40px;
  line-height:40px;
  text-align:center;
  font-size:24px;
  color:#fff;
  margin-top:45px;
}

.map {
  padding: 0 139px 174px 139px;
  height:450px;
}
</style>